<template>
  <body>
    <Header></Header>

    <div class="container">
      <div class="header">
        <img src="about_us.png" class="logo" height="40px" width="70px" />
      </div>
      <div class="sub-container">
        <span class="see">About Us · Visual-Dance</span>
        <div class="center">
          <div class="split"></div>
        </div>

        <p class="watch">
          Yiqing Fan
          <a href="mailto:yiqingfa@usc.edu" target="_blank">(yiqingfa@usc.edu)</a>
        </p>
        <p class="watch">
          Tianyao Wang
          <a href="mailto:tianyaow@usc.edu" target="_blank">(tianyaow@usc.edu)</a>
        </p>
        <p class="watch">
          Fanlin Qin <a href="mailto:fqin@usc.edu" target="_blank">(fqin@usc.edu)</a>
        </p>
        <p class="watch">
          Hanzhe Zhao
          <a href="mailto:hanzhezh@usc.edu" target="_blank">(hanzhezh@usc.edu)</a>
        </p>
      </div>
      <div class="center">
        <router-link to="/">
          <!-- <img src="lufei.jpg" height="50px" width="50px" class='position'> -->
          <img src="back.png" height="50px" width="50px" class="next" />
        </router-link>
      </div>
    </div>
  </body>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "about",
  components: {
    Header,
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #121212;
  /* height: 100vh; */
}
.center {
  display: flex;
  justify-content: center;
}
.logo {
  margin-top: 8%;
}
.container {
  height: 100vh;
  width: 100%;
  text-align: center;
}
.position {
  /* position: absolute;
  top: 8%;
  left: 90%; */
  margin-top: 60px;
}
.position:hover {
  /* opacity: 1; */
}

.sub-container {
  margin-top: 40px;
}

.see {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  font-family: Helvetica;
}

.watch {
  margin-top: 50px;
  font-size: 20px;
  font-weight: 300;
  color: #fff;
  font-family: Helvetica;
}

.split {
  background: rgb(255, 255, 255, 0.8);
  height: 1px;
  width: 460px;
  margin-left: 20%;
  margin-right: 20%;
}

.next {
  margin-top: 50%;
  /* margin-bottom: 50%; */
}

</style>